module.exports = __webpack_public_path__ + "images/emoji/zero.77723b50cc465f718f61.png";